import React          from 'react';
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnBulletList,
  BtnNumberedList,
  BtnStrikeThrough,
  Separator,
  createButton,
  BtnClearFormatting,
  createDropdown,
}                      from 'react-simple-wysiwyg';
import { WithStyle }   from 'rewire-ui';
import { Theme }       from '@material-ui/core/styles';
import AlignLeftIcon   from '@material-ui/icons/FormatAlignLeft';
import AlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import AlignRightIcon  from '@material-ui/icons/FormatAlignRight';
import { withStyles }  from '../utility/styles';
import './richTextBoxStyles.css';

const BtnStyles = createDropdown('Styles', [
  ['Normal', 'formatBlock', 'DIV'],
  ['𝗛𝗲𝗮𝗱𝗲𝗿 𝟭', 'formatBlock', 'H1'],
  ['Header 2', 'formatBlock', 'H2'],
  ['Header 3', 'formatBlock', 'H3'],
]);

const BtnAlignLeft   = createButton('Align left', <AlignLeftIcon style={{fontSize: '1.3rem'}} />, 'justifyLeft');
const BtnAlignCenter = createButton('Align center', <AlignCenterIcon  style={{fontSize: '1.3rem'}} />, 'justifyCenter');
const BtnAlignRight  = createButton('Align right', <AlignRightIcon  style={{fontSize: '1.3rem'}} />, 'justifyRight');

const styles = (_theme: Theme) => ({
  label: {
    fontSize: 10.5,
    color: '#0000008a',
    marginBottom: '8px',
  }
});

interface IRichTextBoxProps {
  label?: string;
  disabled?: boolean;
  value?: string;
  onValueChange: (value?: string) => void;
}

type RichTextBoxProps = WithStyle<ReturnType<typeof styles>, IRichTextBoxProps>;

class RichTextBox extends React.Component<RichTextBoxProps> {
  constructor(props: RichTextBoxProps) {
    super(props);
  }

  onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
    }
  };

  onChange = (e: any) => {
    this.props.onValueChange(e.target.value);
  };

  render() {
    const { classes, label, disabled, value } = this.props;

    return (
      <div onKeyDown={this.onKeyDown}>
      <div className={classes.label}>{label}</div>
      <EditorProvider>
        <Editor
          disabled={disabled}
          value={value}
          onChange={this.onChange}
          >
          <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUnderline />
            <BtnStrikeThrough />
            <Separator />
            <BtnNumberedList />
            <BtnBulletList />
            <Separator />
            <BtnStyles />
            <BtnAlignLeft />
            <BtnAlignCenter />
            <BtnAlignRight />
            <Separator />
            <BtnClearFormatting />
          </Toolbar>
        </Editor>
      </EditorProvider>
      </div>
    );
  }
}

export default withStyles<IRichTextBoxProps>(styles, RichTextBox);
